import request, { FormDataHeader } from '@/utils/request'
import { IWxConfig } from '@/types/wx'

export function wechatSignatureInfo(url = ''): Promise<IWxConfig> {
  return request.post(
    '/wechat/wechat/wechat_signature_info/',
    {
      url: url || window.location.href,
      fromUrl: window.location.href,
    },
    {
      headers: FormDataHeader,
    }
  )
}
